<div
  [ngClass]="[batteryStatus.color, customClass]"
  class="material-symbols-outlined"
>
  {{ batteryStatus.icon }}
</div>
